var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',{attrs:{"show":!_vm.link}},[(_vm.link)?_c('div',[_c('b-embed',{attrs:{"type":"iframe","aspect":"16by9","src":_vm.link,"allowfullscreen":""}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }